import { r as Oe, c as l, h as s, H as je, g as Ce, o as d } from "./main-bb89b2f2.js";
import { D as n } from "./luxon-88c249ba-ecb6bfbf.js";
import { f as r } from "./range-util-748d6b40-19039d16.js";
import { i as Pe, a as De } from "./datepicker-single.util-7e8ffcc1-bf0d36ea.js";
import { T as Me } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
const u = "Datum", p = "tt.mm.jjjj", h = "Anwenden", g = "Abbrechen", b = "Ungültiges Datum ausgewählt", Be = {
  dateLabel: u,
  dateInputPlaceholder: p,
  applyButtonLabel: h,
  cancelButtonLabel: g,
  calendarInputInvalidErrorMessage: b
}, _e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: u,
  dateInputPlaceholder: p,
  applyButtonLabel: h,
  cancelButtonLabel: g,
  calendarInputInvalidErrorMessage: b,
  default: Be
}), S = "Date", I = "dd/mm/yyyy", m = "Apply", y = "Cancel", f = "Invalid Date Selected", xe = {
  dateLabel: S,
  dateInputPlaceholder: I,
  applyButtonLabel: m,
  cancelButtonLabel: y,
  calendarInputInvalidErrorMessage: f
}, ke = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: S,
  dateInputPlaceholder: I,
  applyButtonLabel: m,
  cancelButtonLabel: y,
  calendarInputInvalidErrorMessage: f,
  default: xe
}), L = "Fecha", v = "dd/mm/aaaa", O = "Confirmar", j = "Cancelar", C = "Fecha inválida seleccionada", Ee = {
  dateLabel: L,
  dateInputPlaceholder: v,
  applyButtonLabel: O,
  cancelButtonLabel: j,
  calendarInputInvalidErrorMessage: C
}, $e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: L,
  dateInputPlaceholder: v,
  applyButtonLabel: O,
  cancelButtonLabel: j,
  calendarInputInvalidErrorMessage: C,
  default: Ee
}), P = "Date", D = "jj.mm.aaaa", M = "Confirmer", B = "Annuler", _ = "Date invalide sélectionnée", ze = {
  dateLabel: P,
  dateInputPlaceholder: D,
  applyButtonLabel: M,
  cancelButtonLabel: B,
  calendarInputInvalidErrorMessage: _
}, we = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: P,
  dateInputPlaceholder: D,
  applyButtonLabel: M,
  cancelButtonLabel: B,
  calendarInputInvalidErrorMessage: _,
  default: ze
}), x = "Data", k = "gg/mm/aaaa", E = "Confermare", $ = "Annullare", z = "Data non valida selezionata", Ve = {
  dateLabel: x,
  dateInputPlaceholder: k,
  applyButtonLabel: E,
  cancelButtonLabel: $,
  calendarInputInvalidErrorMessage: z
}, Te = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: x,
  dateInputPlaceholder: k,
  applyButtonLabel: E,
  cancelButtonLabel: $,
  calendarInputInvalidErrorMessage: z,
  default: Ve
}), w = "日付：", V = "yyyy/mm/dd", T = "確認", J = "キャンセル", R = "無効な日付が選択されました", Je = {
  dateLabel: w,
  dateInputPlaceholder: V,
  applyButtonLabel: T,
  cancelButtonLabel: J,
  calendarInputInvalidErrorMessage: R
}, Re = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: w,
  dateInputPlaceholder: V,
  applyButtonLabel: T,
  cancelButtonLabel: J,
  calendarInputInvalidErrorMessage: R,
  default: Je
}), A = "날짜", Y = "yyyy. mm. dd", N = "확인", W = "취소", F = "잘못된 날짜가 선택되었습니다", Ae = {
  dateLabel: A,
  dateInputPlaceholder: Y,
  applyButtonLabel: N,
  cancelButtonLabel: W,
  calendarInputInvalidErrorMessage: F
}, Ye = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: A,
  dateInputPlaceholder: Y,
  applyButtonLabel: N,
  cancelButtonLabel: W,
  calendarInputInvalidErrorMessage: F,
  default: Ae
}), H = "Datum", q = "tt-mm-jjjj", U = "Bevestigen", G = "Staken", K = "Ongeldige datum geselecteerd", Ne = {
  dateLabel: H,
  dateInputPlaceholder: q,
  applyButtonLabel: U,
  cancelButtonLabel: G,
  calendarInputInvalidErrorMessage: K
}, We = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: H,
  dateInputPlaceholder: q,
  applyButtonLabel: U,
  cancelButtonLabel: G,
  calendarInputInvalidErrorMessage: K,
  default: Ne
}), Q = "Data", X = "dd.mm.rrrr", Z = "potwierdzać", ee = "Anuluj", te = "Wybrano nieprawidłową datę", Fe = {
  dateLabel: Q,
  dateInputPlaceholder: X,
  applyButtonLabel: Z,
  cancelButtonLabel: ee,
  calendarInputInvalidErrorMessage: te
}, He = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: Q,
  dateInputPlaceholder: X,
  applyButtonLabel: Z,
  cancelButtonLabel: ee,
  calendarInputInvalidErrorMessage: te,
  default: Fe
}), ae = "Data", ne = "dd/mm/aaaa", le = "Aplicar", ie = "Cancelar", se = "Data inválida selecionada", qe = {
  dateLabel: ae,
  dateInputPlaceholder: ne,
  applyButtonLabel: le,
  cancelButtonLabel: ie,
  calendarInputInvalidErrorMessage: se
}, Ue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: ae,
  dateInputPlaceholder: ne,
  applyButtonLabel: le,
  cancelButtonLabel: ie,
  calendarInputInvalidErrorMessage: se,
  default: qe
}), re = "Дата", oe = "дд.мм.гггг", ce = "Применить", de = "Отмена", ue = "Выбрана недопустимая дата", Ge = {
  dateLabel: re,
  dateInputPlaceholder: oe,
  applyButtonLabel: ce,
  cancelButtonLabel: de,
  calendarInputInvalidErrorMessage: ue
}, Ke = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: re,
  dateInputPlaceholder: oe,
  applyButtonLabel: ce,
  cancelButtonLabel: de,
  calendarInputInvalidErrorMessage: ue,
  default: Ge
}), pe = "Tarih", he = "gg.aa.yyyy", ge = "Uygula", be = "İptal", Se = "Geçersiz tarih seçildi", Qe = {
  dateLabel: pe,
  dateInputPlaceholder: he,
  applyButtonLabel: ge,
  cancelButtonLabel: be,
  calendarInputInvalidErrorMessage: Se
}, Xe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: pe,
  dateInputPlaceholder: he,
  applyButtonLabel: ge,
  cancelButtonLabel: be,
  calendarInputInvalidErrorMessage: Se,
  default: Qe
}), Ie = "日期", me = "yyyy/mm/dd", ye = "应用", fe = "取消", Le = "选择的日期无效", Ze = {
  dateLabel: Ie,
  dateInputPlaceholder: me,
  applyButtonLabel: ye,
  cancelButtonLabel: fe,
  calendarInputInvalidErrorMessage: Le
}, et = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  dateLabel: Ie,
  dateInputPlaceholder: me,
  applyButtonLabel: ye,
  cancelButtonLabel: fe,
  calendarInputInvalidErrorMessage: Le,
  default: Ze
}), tt = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.static{position:static}.mt-\\[8px\\]{margin-top:8px}.flex{display:flex}.items-center{align-items:center}.visible{visibility:visible}.invisible{visibility:hidden}.right-4{right:var(--spacing-4)}.right-\\[80px\\]{right:80px}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.gap-4{gap:var(--spacing-4)}.\\!pr-\\[42px\\]{padding-right:42px!important}.\\!pr-\\[84px\\]{padding-right:84px!important}.blur{--tw-blur:blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.inline-block{display:inline-block}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.p-0{padding:var(--spacing-0)}.px-0{padding-left:var(--spacing-0);padding-right:var(--spacing-0)}.pr-4{padding-right:var(--spacing-4)}.pl-4{padding-left:var(--spacing-4)}.pl-5{padding-left:var(--spacing-5)}.text-left{text-align:left}.text-center{text-align:center}", at = tt, nt = {
  de: _e,
  en: ke,
  es: $e,
  fr: we,
  it: Te,
  ja: Re,
  pt: Ue,
  ru: Ke,
  zh: et,
  ko: Ye,
  nl: We,
  pl: He,
  tr: Xe
}, lt = class {
  constructor(e) {
    Oe(this, e), this.lhDatepickerSingleSelection = l(this, "lhDatepickerSingleSelection", 7), this.lhDatepickerSingleClear = l(this, "lhDatepickerSingleClear", 7), this.lhDatepickerSingleOpen = l(this, "lhDatepickerSingleOpen", 7), this.lhDatepickerSingleClose = l(this, "lhDatepickerSingleClose", 7), this.lhChange = l(this, "lhChange", 7), this.supportedLangs = ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pl", "pt", "ru", "tr", "zh"], this.internalState = {
      value: null,
      // represents the Prop() value in the internal state as Date objects
      selection: null,
      isCalendarOpen: !1,
      isSelectionValid: !1,
      locale: "en",
      // fallback to lang attr
      debug: !1,
      displayedMonth: null,
      // Set current month to the current date by default
      yearRange: { past: 5, future: 5 },
      i18n: {},
      customizableTextInputProps: {},
      minimum: null,
      maximum: null,
      calendarInputStatus: "default",
      calendarInputValue: "",
      hasSlottedInput: !1,
      calendarYearSelectOptions: []
    }, this.additionalInfo = void 0, this.additionalInfoPosition = void 0, this.controlled = !1, this.disabled = void 0, this.display = void 0, this.errorText = void 0, this.infoText = void 0, this.label = void 0, this.size = "L", this.status = void 0, this.successText = void 0, this.usePlaceholderHeight = void 0, this.value = void 0, this.warningText = void 0, this.wcag = "AA", this.yearRangeFuture = 5, this.yearRangePast = 5, this.minimum = void 0, this.maximum = void 0, this.displayedMonth = (/* @__PURE__ */ new Date()).toISOString();
  }
  /** @internal */
  async getInternalState() {
    return Promise.resolve(this.internalState);
  }
  // Watchers
  handleCustomizableTextInputPropsChange(e, t, a) {
    this.updateCustomizableProps({ [a]: e });
  }
  // Utility to update customizableTextInputProps in internalState
  updateCustomizableProps(e) {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { customizableTextInputProps: Object.assign(Object.assign({}, this.internalState.customizableTextInputProps), e) });
  }
  valueWatcher(e, t) {
    this.handleValueChange(e);
  }
  datepickerSingleStateWatcher(e, t) {
    e.debug && console.log("Old State", t, "New State", e);
  }
  yearRangePastWatcher(e) {
    const t = Object.assign(Object.assign({}, this.internalState.yearRange), { past: e });
    this.internalState = Object.assign(Object.assign({}, this.internalState), { yearRange: t });
  }
  yearRangeFutureWatcher(e) {
    const t = Object.assign(Object.assign({}, this.internalState.yearRange), { future: e });
    this.internalState = Object.assign(Object.assign({}, this.internalState), { yearRange: t });
  }
  displayedMonthWatcher(e) {
    const t = n.fromISO(e);
    t.isValid ? this.updateDisplayedMonthState(t.toJSDate()) : (this.updateDisplayedMonthState(/* @__PURE__ */ new Date()), console.warn("Could not create date from provided value for displayedMonth. Did you remember to provide a date formatted by .toISOString()?"));
  }
  handleEscapePress(e) {
    e.key === "Escape" && (this.closeCalendar(), this.lhDatepickerSingleClose.emit());
  }
  handleInputValueChange(e) {
    this.debugEvent("controller received __lhInternalDatepickerSingleInputValueChanged:", e.detail), e.stopImmediatePropagation(), this.dateWasDeleted(e) ? this.handleDelete() : this.handleInput(e);
  }
  handleClear(e) {
    this.debugEvent("controller received lhDatepickerSingleClear"), e.stopImmediatePropagation(), this.lhDatepickerSingleClear.emit(), this.controlled || (this.value = ""), this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: null, calendarInputValue: "", calendarInputStatus: "default", isSelectionValid: !1 });
  }
  handleCancel(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleCancelSelection"), this.closeCalendar(), this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: this.internalState.value }), this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputStatus: "default" });
    const t = this.getSelectionValidity();
    this.udpateSelectionValidity(t);
  }
  handleApply(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleApplySelection"), this.closeCalendar(), this.controlled || (this.value = this.formatDatepickerSingleAsString(this.internalState.selection)), this.lhChange.emit(this.internalState.selection), this.debugEvent("controller emited lhChange", this.internalState.selection);
  }
  handleDayClick(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleDayClick:", e.detail);
    const t = e.detail;
    this.lhDatepickerSingleSelection.emit(t), this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: t, calendarInputValue: r(t) }), this.updateValidity();
  }
  handleMonthChange(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleDisplayedMonthChange:", e.detail);
    const { month: t, year: a } = e.detail, i = n.local().setLocale(this.internalState.locale).set({ month: t, year: a }).toJSDate(), o = this.generateYearOptions(i);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: i, calendarYearSelectOptions: o });
  }
  handleDatepickerSingleClose(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleClose"), this.closeCalendar(), this.lhDatepickerSingleClose.emit();
  }
  handleCalendarShow(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleOpen"), this.setCurrentValueAsSelection(), this.setCurrentValueAsDisplayedDate(), this.setCurrentValueAsInputValue(), this.openCalendar(), this.lhDatepickerSingleOpen.emit();
  }
  handlePreviousMonthClick(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSinglePreviousMonthClick");
    const t = n.fromJSDate(this.internalState.displayedMonth).minus({ months: 1 }).toJSDate();
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: t });
  }
  handleNextMonthClick(e) {
    e.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDatepickerSingleNextMonthClick");
    const t = n.fromJSDate(this.internalState.displayedMonth).plus({ months: 1 }).toJSDate();
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: t });
  }
  connectedCallback() {
    this.setupLocale(), this.setupValue(), this.setupYearRange(), this.setupCustomizableInputProps(), this.setupMinMax(), this.setupDisplayedMonth(), this.setupYearOptions();
  }
  componentDidLoad() {
    this.updateSlottedInputState();
  }
  disconnectedCallback() {
    this.languageObserver.disconnect();
  }
  render() {
    return s(je, { key: "af27b85021632923bd0c0e721eeaebb348fbcd0e", "data-testid": "datepicker-single" }, s("patternlib-datepicker-single-view", { key: "ccfd38296f9187b42943e67b73de7fd5031f741e", "data-testid": "single-view", state: this.internalState }, s("slot", { key: "f1cd895bd1abe5c873761b120952438766966e66", onSlotchange: this.handleInputSlotChange.bind(this), name: "calendar-input", slot: "calendar-input" })));
  }
  clearDatepickerSingleState() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { value: null, selection: null });
  }
  closeCalendar() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { isCalendarOpen: !1 });
  }
  debugEvent(e, t) {
    this.internalState.debug && console.debug(e, t);
  }
  formatDatepickerSingleAsString(e) {
    return ((a) => a ? n.fromJSDate(a).toISO() : "")(e);
  }
  // Validation logic
  getSelectionValidity() {
    const e = this.internalState.selection !== null, t = !Pe(n.fromJSDate(this.internalState.selection), n.fromISO(this.minimum)), a = !De(n.fromJSDate(this.internalState.selection), n.fromISO(this.maximum));
    return e && t && a;
  }
  handleValueChange(e) {
    this.isValueEmpty(e) ? this.clearDatepickerSingleState() : (this.updateValue(e), this.updateValidity());
  }
  isValueEmpty(e) {
    return e === "";
  }
  openCalendar() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { isCalendarOpen: !0 });
  }
  setCurrentValueAsSelection() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: this.internalState.value });
  }
  setupCustomizableInputProps() {
    this.internalState.customizableTextInputProps = Object.assign(Object.assign({}, this.internalState.customizableTextInputProps), { additionalInfo: this.additionalInfo, additionalInfoPosition: this.additionalInfoPosition, errorText: this.errorText, infoText: this.infoText, label: this.label, disabled: this.disabled, readonly: this.display, size: this.size, status: this.status, successText: this.successText, warningText: this.warningText, usePlaceholderHeight: this.usePlaceholderHeight, wcag: this.wcag });
  }
  setupLocale() {
    const e = document.documentElement.getAttribute("lang") || "en";
    this.updateI18NState(e);
    const t = (a) => {
      this.internalState = Object.assign(Object.assign({}, this.internalState), { locale: d("lang", a) || e }), this.updateI18NState(d("lang", a) || e);
    };
    this.languageObserver = new MutationObserver(t), this.languageObserver.observe(document.documentElement, { attributes: !0 });
  }
  setupValue() {
    this.value && (this.updateValue(this.value), this.updateValidity());
  }
  setupYearRange() {
    let e = { past: 5, future: 5 };
    typeof this.yearRangeFuture == "number" && (e.past = this.yearRangePast), typeof this.yearRangeFuture == "number" && (e.future = this.yearRangeFuture), this.internalState = Object.assign(Object.assign({}, this.internalState), { yearRange: e });
  }
  updateI18NState(e) {
    const t = this.supportedLangs.includes(e) ? e : "en";
    this.internalState = Object.assign(Object.assign({}, this.internalState), { locale: t });
    const a = Me.resolveJsonBasedOnLanguage(t, nt);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { i18n: a });
  }
  updateValidity() {
    const e = this.getSelectionValidity();
    this.udpateSelectionValidity(e), this.updateInputValidity(e);
  }
  updateInputValidity(e) {
    e ? this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputStatus: "default" }) : this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputStatus: "error" });
  }
  udpateSelectionValidity(e) {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { isSelectionValid: e });
  }
  updateValue(e) {
    this.internalState.value = new Date(e);
  }
  setupMinMax() {
    this.setupMinimum(), this.setupMaximum();
  }
  setupMinimum() {
    const e = n.fromISO(this.minimum);
    e.isValid && (this.internalState.minimum = e.toJSDate());
  }
  setupMaximum() {
    const e = n.fromISO(this.maximum);
    e.isValid && (this.internalState.maximum = e.toJSDate());
  }
  setupDisplayedMonth() {
    const e = n.fromISO(this.displayedMonth);
    e.isValid ? this.updateDisplayedMonthState(e.toJSDate()) : (this.updateDisplayedMonthState(/* @__PURE__ */ new Date()), console.warn("Could not create date from provided value for displayedMonth. Did you remember to provide a date formatted with Date.prototype.toISOString()?"));
  }
  updateDisplayedMonthState(e) {
    e !== null && (this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: e }));
  }
  setCurrentValueAsDisplayedDate() {
    this.internalState.value !== null && (this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: this.internalState.value }));
  }
  dateWasDeleted(e) {
    return e.detail === null;
  }
  handleDelete() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: null, isSelectionValid: !1 });
  }
  handleInput(e) {
    const a = { calendarInputValue: r(e.detail), selection: e.detail };
    this.internalState = Object.assign(Object.assign({}, this.internalState), a), this.updateValidity(), this.updateDisplayedMonthState(e.detail);
  }
  handleInputSlotChange() {
    this.updateSlottedInputState();
  }
  updateSlottedInputState() {
    const e = this.hostElement.shadowRoot.querySelector('slot[name="calendar-input"]'), a = (e == null ? void 0 : e.assignedNodes()).length > 0;
    this.internalState = Object.assign(Object.assign({}, this.internalState), { hasSlottedInput: a });
  }
  generateYearOptions(e) {
    const t = n.fromJSDate(e).year, a = t - this.internalState.yearRange.past, i = t + this.internalState.yearRange.future;
    return Array.from({ length: i - a + 1 }, (o, ve) => {
      const c = a + ve;
      return { value: c, label: c.toString() };
    });
  }
  setupYearOptions() {
    const e = this.generateYearOptions(this.internalState.displayedMonth);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarYearSelectOptions: e });
  }
  setCurrentValueAsInputValue() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputValue: r(this.internalState.value), calendarInputStatus: "default" });
  }
  get hostElement() {
    return Ce(this);
  }
  static get watchers() {
    return {
      additionalInfo: ["handleCustomizableTextInputPropsChange"],
      additionalInfoPosition: ["handleCustomizableTextInputPropsChange"],
      errorText: ["handleCustomizableTextInputPropsChange"],
      infoText: ["handleCustomizableTextInputPropsChange"],
      label: ["handleCustomizableTextInputPropsChange"],
      disabled: ["handleCustomizableTextInputPropsChange"],
      readonly: ["handleCustomizableTextInputPropsChange"],
      size: ["handleCustomizableTextInputPropsChange"],
      status: ["handleCustomizableTextInputPropsChange"],
      successText: ["handleCustomizableTextInputPropsChange"],
      warningText: ["handleCustomizableTextInputPropsChange"],
      usePlaceholderHeight: ["handleCustomizableTextInputPropsChange"],
      wcag: ["handleCustomizableTextInputPropsChange"],
      value: ["valueWatcher"],
      internalState: ["datepickerSingleStateWatcher"],
      yearRangePast: ["yearRangePastWatcher"],
      yearRangeFuture: ["yearRangeFutureWatcher"],
      displayedMonth: ["displayedMonthWatcher"]
    };
  }
};
lt.style = at;
export {
  lt as patternlib_datepicker_single
};
